import HttpClient from './HttpClient'

const extractEdgeNodes = node => {
  if (node && node.edges) {
    return node.edges.map(
      edge => edge.node
    )
  }

  return []
}

class ShopifyClient extends HttpClient {
  extractEdgeNodes(...args) {
    return extractEdgeNodes(...args)
  }

  constructor(options) {
    super({
      timeout: options.shopifyTimeout,
      baseURL: options.shopifyBaseURL,
      serverBaseURL: options.shopifyBaseURL,
      headers: {
        'Content-type': 'application/json',
        'X-Shopify-Storefront-Access-Token': options.shopifyToken
      }
    })
  }

  extractResponseError(resData) {
    let message

    if (resData.error) {
      message = resData.error.message
    } else if (resData.errors) {
      message = resData.errors.map(error => error.message).join('|')
    }

    if (message) {
      return {
        errorMessage: message
      }
    }

    return null
  }

  /* ------------------------------------------- */

  query(query, variables, options = {}) {
    return this.send({
      ...options,
      url: '',// always send to base entry which has been setup via baseURL
      method: 'post',
      data: {
        query,
        variables
      },
    })
  }

}

export default ShopifyClient